// Palette e temi condivisi dai diagrammi schematici line-art (TechDiagram, IpSchema).
// Allineato a window.DGM del prototipo. Solo dati/tipi: niente componenti, così i file
// che importano da qui restano fast-refresh-friendly.

export const PAL = {
  navy900: '#142137',
  navy700: '#15316F',
  navy500: '#1E4AA8',
  cyan: '#11B1E9',
  azure: '#3DA0FF',
  violet: '#8A5CFF',
  magenta: '#FF3EA5',
  gold: '#E6B24A',
  line: '#E4E1D7',
  ink: '#0A1024',
  muted: '#4A5267',
}

export interface Theme {
  stroke: string
  dim: string
  fillSoft: string
  label: string
  sub: string
}

export const DARK: Theme = {
  stroke: 'rgba(255,255,255,0.92)',
  dim: 'rgba(255,255,255,0.40)',
  fillSoft: 'rgba(255,255,255,0.06)',
  label: 'rgba(255,255,255,0.92)',
  sub: 'rgba(255,255,255,0.45)',
}

export const LIGHT: Theme = {
  stroke: PAL.navy900,
  dim: 'rgba(20, 33, 55,0.30)',
  fillSoft: 'rgba(20, 33, 55,0.04)',
  label: PAL.ink,
  sub: PAL.muted,
}
